import React from 'react';
import { Link } from 'react-router-dom';

const NotAuthorized: React.FC = () => {
  return (
    <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-full'>
      <div className='mx-auto max-w-3xl h-full flex flex-col justify-center align-start'>
        <h1 className='text-4xl'>403 Not Authorized</h1>
        <Link
          to='/'
          className='font-medium mt-2 text-lg text-blue-500 hover:text-blue-400'
        >
          Go home
        </Link>
      </div>
    </div>
  );
};

export default NotAuthorized;
